(() => {
    const MODULE_NAME = 'oc-sc-diff',
        BRANDING_CLASS = '.branding',
        THUMBNAIL_OVERLAY_CLASS = '.thumbnail-overlay',
        OC_SC_DIFF_CALSS = 'tbl-oc-sc-diff',
        VARIANT_THUMBS_1 = 'tbl-thumbs-blue',
        VARIANT_THUMBS_2 = 'tbl-thumbs-white',
        VARIANT_3_BOTTOM_LINE = 'tbl-bottom-line';

    class OCSCDiff {
        constructor(thumbBlock, videoLabelBox, variant) {
            this.branding = videoLabelBox.querySelector(BRANDING_CLASS);
            this.thumbnailOverlay = thumbBlock.querySelector(THUMBNAIL_OVERLAY_CLASS);
            this.variant = variant;

            if (this.branding
                && this.thumbnailOverlay
                && this.variant !== VARIANT_3_BOTTOM_LINE) {
                this.thumbnailOverlay.insertAdjacentElement('afterbegin', this.branding);
            }
            this.classInjector(thumbBlock);
        }

        /**
         * Add class according to the variant
         * If variant is tbl-bottom-line , the calls will be appended to thumbBlock_holder
         * @param thumbBlock -  thumbBlock.parentElement === thumbBlock_holder
         */
        classInjector(thumbBlock) {
            TRC.dom.addClass(this.thumbnailOverlay, OC_SC_DIFF_CALSS);
            TRC.dom.addClass(thumbBlock.parentElement, OC_SC_DIFF_CALSS);

            if (this.variant === VARIANT_THUMBS_1 && this.branding) {
                TRC.dom.addClass(this.branding, VARIANT_THUMBS_1);
            } else if (this.variant === VARIANT_THUMBS_2 && this.branding) {
                TRC.dom.addClass(this.branding, VARIANT_THUMBS_2);
            } else if (this.variant === VARIANT_3_BOTTOM_LINE) {
                TRC.dom.addClass(thumbBlock.parentElement, VARIANT_3_BOTTOM_LINE);
            }
        }
    }

    /**
     * This module works only on responsive modes (depands on thumbnails overlay in variants 1 and 2
     * If there is no variant in the configuration - the new module will not be evoke.
     * Variants names are in the const(s) variables
     *
     * @type {{'list-suffix': OCSCDiff.hooks.list-suffix}}
     */
    OCSCDiff.hooks = {
        'list-suffix': function (internalTRC, data) {
            const dataBoxes = data.boxes,
                itemsLength = dataBoxes && dataBoxes.length,
                moduleInfoObj = TRC.CustomModulesManager
                    && TRC.CustomModulesManager.registeredModules[MODULE_NAME]
                    && TRC.CustomModulesManager.registeredModules[MODULE_NAME].options,
                classOfVariant = moduleInfoObj.variant;

            for (let i = 0; i < itemsLength; i++) {
                const item = dataBoxes[i];
                if (item
                    && item.hasAttribute('data-item-syndicated')
                    && item.getAttribute('data-item-syndicated') === 'false'
                    && classOfVariant
                    && item.thumbBlock
                    && item.labelsBox) {
                    new OCSCDiff(item.thumbBlock, item.labelsBox, classOfVariant);
                }
            }
        }
    };

    TRC.customHooks[MODULE_NAME] = OCSCDiff;
})();
